import { getNativeCurrency } from '@/config/native'
import { CDONT, DONT, TDONT } from '@/config/tokens'
import {
  DEFAULT_TOKEN_BANNER_URL,
  resolveTokenProfileBannerUrl,
  resolveTokenProfileIconUrl,
} from '@/constants/tokenImages'
import { isNativeLegAddress, NATIVE_TOKEN_ADDRESS } from '@sirius-cybernetics-42/product-config'
import { ChainId } from '@/sdk'

import type { MarketTokenProfile } from '../types'

export { NATIVE_TOKEN_ADDRESS }

function normalizeAddress(address: string): string {
  return address.toLowerCase()
}

function getDontPanicToken(chainId: ChainId) {
  if (chainId === ChainId.INFINITE_CREATIVE) return CDONT
  if (chainId === ChainId.INFINITE_TESTNET) return TDONT
  if (chainId === ChainId.INFINITE_MAINNET) return DONT
  return undefined
}

export function isEssentialTokenAddress(address: string, chainId: ChainId): boolean {
  const key = normalizeAddress(address)
  if (isNativeLegAddress(key)) return true
  const dont = getDontPanicToken(chainId)
  return dont != null && normalizeAddress(dont.address) === key
}

function buildNativeProfile(chainId: ChainId): MarketTokenProfile {
  const native = getNativeCurrency(chainId)
  return {
    address: NATIVE_TOKEN_ADDRESS,
    symbol: native.symbol ?? 'NATIVE',
    name: native.name ?? 'Native',
    decimals: native.decimals,
    description: `Activo nativo de gas en ${native.name ?? 'la cadena'}.`,
    iconUrl: resolveTokenProfileIconUrl(NATIVE_TOKEN_ADDRESS),
    bannerUrl: DEFAULT_TOKEN_BANNER_URL,
    tags: ['Native', 'Gas'],
    socials: [],
    priceUsd: '—',
    change24h: '—',
    marketCap: '—',
    volume24h: '—',
    totalSupply: '—',
    circulatingSupply: '—',
    holders: '—',
    launchedAt: '—',
    role: 'native',
  }
}

export function getEssentialTokenProfile(address: string, chainId: ChainId): MarketTokenProfile | null {
  const key = normalizeAddress(address)

  if (isNativeLegAddress(key)) {
    return buildNativeProfile(chainId)
  }

  const dont = getDontPanicToken(chainId)
  if (dont && normalizeAddress(dont.address) === key) {
    return {
      address: dont.address,
      symbol: dont.symbol ?? 'PANIC',
      name: dont.name ?? 'DONT PANIC',
      decimals: dont.decimals,
      description:
        'DONT PANIC es el token de utilidad del ecosistema.',
      iconUrl: resolveTokenProfileIconUrl(dont.address),
      bannerUrl: resolveTokenProfileBannerUrl(),
      tags: ['Utility', 'Brand'],
      socials: [],
      priceUsd: '—',
      change24h: '—',
      marketCap: '—',
      volume24h: '—',
      totalSupply: '—',
      circulatingSupply: '—',
      holders: '—',
      launchedAt: '—',
    }
  }

  return null
}
